define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "prop-types", "../../themes", "styled-components", "./HeaderScroll"], function (_exports, _taggedTemplateLiteralLoose2, _react, _propTypes, _themes, _styledComponents, _HeaderScroll) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  _HeaderScroll = _interopRequireDefault(_HeaderScroll);

  var _templateObject;

  var fixedHeader = (0, _styledComponents.keyframes)(["from{top:70px;transform:translate3d(0,0,0);}to{top:90px;transform:translate3d(0,0,0);}"]);

  var BoxShadowStyled = _styledComponents.default.div.withConfig({
    displayName: "CvContainer__BoxShadowStyled",
    componentId: "sc-qsyvfb-0"
  })(["background-color:", ";border-radius:4px;box-shadow:0 1px 2px 0 rgba(0,0,0,0.3);display:flex;flex-direction:column;left:0;position:fixed;top:0;width:100%;@media print{box-shadow:none;position:absolute;}", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    min-height: calc(100vh - (", " * 2));\n      min-width: 500px;\n    position: relative;\n  "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.scafolding.headerHeight;
  }));

  var HeaderHidden = _styledComponents.default.div.withConfig({
    displayName: "CvContainer__HeaderHidden",
    componentId: "sc-qsyvfb-1"
  })(["", ""], function (_ref3) {
    var show = _ref3.show;
    return show && (0, _styledComponents.css)(["animation:", " 0.6s ", " both;position:fixed;top:90px;width:100%;z-index:2;> div ~ div{display:flex;}"], fixedHeader, function (_ref4) {
      var theme = _ref4.theme;
      return theme.easing.ease;
    });
  });

  var CvContainer = function CvContainer(_ref5) {
    var cvData = _ref5.cvData,
        children = _ref5.children,
        avatarUrl = _ref5.avatarUrl,
        toggleTopbarRerender = _ref5.toggleTopbarRerender,
        headerScrollChildren = _ref5.headerScrollChildren,
        shouldHideFixedMiniHeader = _ref5.shouldHideFixedMiniHeader;

    var _useState = (0, _react.useState)(true),
        wasScroll = _useState[0],
        setScroll = _useState[1];

    var _useState2 = (0, _react.useState)(''),
        size = _useState2[0],
        setSize = _useState2[1];

    var elRef = (0, _react.useRef)();

    function updateBoundingClientRect() {
      if (elRef.current) {
        setSize(elRef.current.getBoundingClientRect().width);
        setScroll(elRef.current.getBoundingClientRect().top <= 90);
      }
    }

    (0, _react.useEffect)(function () {
      updateBoundingClientRect();
    }, [toggleTopbarRerender]);
    (0, _react.useEffect)(function () {
      updateBoundingClientRect();
      window.addEventListener('scroll', updateBoundingClientRect);
      window.addEventListener('resize', updateBoundingClientRect);
      return function () {
        window.removeEventListener('scroll', updateBoundingClientRect);
        window.removeEventListener('resize', updateBoundingClientRect);
      };
    }, []);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BoxShadowStyled, {
      ref: elRef
    }, /*#__PURE__*/_react.default.createElement(HeaderHidden, {
      style: {
        width: parseInt(size) + 'px'
      },
      show: wasScroll
    }, shouldHideFixedMiniHeader ? null : /*#__PURE__*/_react.default.createElement(_HeaderScroll.default, {
      showHeader: wasScroll,
      img: avatarUrl,
      id: cvData.profissional_id,
      name: cvData.nome,
      age: cvData.idade
    }), headerScrollChildren), children));
  };

  CvContainer.defaultProps = {
    cvData: {},
    children: _propTypes.node,
    avatarUrl: '',
    shouldHideFixedMiniHeader: false
  };
  var _default = CvContainer;
  _exports.default = _default;
});